import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SelectedAnswer {
  exercise_id: number;
  selected_answer: number | -1;
}

interface SelfTestState {
  selected_test_id: number | null;
  selected_answers: Record<number, SelectedAnswer>;
  history_id: number | null;

  setSelectedTestId: (testId: number) => void;
  saveSelectedAnswer: (exercise_id: number, answer_id: number | -1) => void;
  getSelectedAnswer: (exercise_id: number) => SelectedAnswer | null;

  setHistoryId: (id: number | null) => void;
  clearAll: () => void;
}

export const useSelfTestStore = create(
  persist<SelfTestState>(
    (set, get) => ({
      selected_test_id: null,
      selected_answers: {},
      history_id: null,

      setSelectedTestId: (testId) => set({ selected_test_id: testId }),

      saveSelectedAnswer: (exercise_id, answer_id) =>
        set({
          selected_answers: {
            ...get().selected_answers,
            [exercise_id]: {
              exercise_id,
              selected_answer: answer_id,
            },
          },
        }),

      getSelectedAnswer: (exercise_id) =>
        get().selected_answers[exercise_id] || null,

      setHistoryId: (id) => set({ history_id: id }),

      clearAll: () =>
        set({
          selected_test_id: null,
          selected_answers: {},
          history_id: null,
        }),
    }),
    {
      name: "shoonit-selected-exercise-test",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
